import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter: React.FC = () => (
  <footer className="border-t border-[var(--border)] px-4 sm:px-6 py-6 sm:py-8">
    <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[var(--text-muted)]">
      <span>© {new Date().getFullYear()} TravelMinds</span>
      <div className="flex gap-4">
        <Link to="/pricing" className="hover:text-[var(--text)]">Pricing</Link>
        <Link to="/faq" className="hover:text-[var(--text)]">FAQ</Link>
        <Link to="/help" className="hover:text-[var(--text)]">Help</Link>
        <Link to="/login" className="hover:text-[var(--text)]">Sign In</Link>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
